import { useMemo, useState } from 'react';

import { iaRa } from 'lib/helpers/utility';
import { useVerifyInvoicePatient } from 'lib/hooks/queries/public/useVerifyInvoicePatient';

export const useVerifiedPatient = ({ token, invoice }) => {
  const [isVerifyOpen, setIsVerifyOpen] = useState(false);

  const { mutate, data, variables, isLoading } = useVerifyInvoicePatient({
    onSuccess: () => setIsVerifyOpen(false)
  });

  const verifiedPatient = data?.code === 0 && variables?.token === token ? data?.patient : null;

  const verifiedInvoice = useMemo(() => {
    if (!invoice || !verifiedPatient) return invoice;

    return {
      ...invoice,
      patient: verifiedPatient,
      internal_invoices: iaRa(invoice.internal_invoices).map((internal) => ({
        ...internal,
        patient: verifiedPatient
      }))
    };
  }, [invoice, verifiedPatient]);

  return {
    invoice: verifiedInvoice,
    isVerifyOpen,
    isVerifying: isLoading,
    openVerify: () => setIsVerifyOpen(true),
    closeVerify: () => setIsVerifyOpen(false),
    verify: (values) => mutate({ ...values, token })
  };
};
